import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
// import deep-equal
import equal from "deep-equal";
// import store
import { connect } from "react-redux";
// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setArticle,
  setOpportunity,
  togglePreloader,
} from "../../store/actions";
// import constants
import { APP_TOKEN } from "../../helpers/constants";
// import services
import {
  getOpportunities,
  getFilterOpportunities,
  getOpportunitiesFilterFields,
} from "../../services/opportunityService";
// import utilities
import { isUnauthenticatedRequest } from "../../helpers/utilities";
import { Form, Col } from "react-bootstrap";
// import common components
import Banner from "../../components/common/Banner";
import Leading from "../../components/common/Leading";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Section from "../../components/common/Section";
import Maper from "../../components/common/Maper";
// import custom components
import SlideArticle from "../../components/custom/articles/SlideArticle";
import ListOpportunity from "../../components/custom/opportunities/ListOpportunity";
import FilterOpportunity from "../../components/custom/opportunities/FilterOpportunity";
import Selecter from "../../components/common/Selecter";
import CommonIcon from "../../components/common/CommonIcon";
// import marker image
import { mkOpportunity } from "../../assets/images";
import { propTypes } from "react-bootstrap/esm/Image";
import { useDispatch, useSelector } from "react-redux";
import { LEVELS } from "../../helpers/dummies";

export default function NewOpportunity() {
  const dispatch = useDispatch();
  const isPreloader = useSelector((state) => state.isPreloader);
  const history = useHistory();
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0); // Scroll to the top of the page when route changes
    });

    return () => {
      unlisten(); // Cleanup the listener when the component unmounts
    };
  }, [history]);

  const [data, setData] = useState({});
  const [pagination, setPagination] = useState({
    limit: 11,
    page: 0,
  });
  const [loading, setLoading] = useState(false);
  const [opportunities, setOpportunities] = useState([]);
  const [oportunitiesCount, setOpportunitiesCount] = useState(0);
  // const [coordinates, setCoordinates] = useState([
  //   { coordinates: { lat: 28.207609, lng: 79.82666 } },
  // ]);
  const [coordinates, setCoordinates] = useState([
    { coordinates: { lat: 28.207609, lng: 79.82666 } },
  ]);
  const [filterfileds, setFilterFileds] = useState({
    categories: [],
    countries: [],
    formationlevel: [],
    nationality: [],
    time: [],
    // limit:10,
    // page:0,
  });

  const totalPage = Math.ceil(oportunitiesCount / pagination.limit);
  // const opportunities = useSelector((state) => state.opportunities);
  // console.log("opportunities", { opportunities });
  const onSelected = (selected, option) => {
    setData({ ...data, [option]: [selected] });
  };

  const handleCardClick = () => {
    // Implement your desired action when the card is clicked
    console.log("Card clicked!");
  };

  const redirectToHomePage = () => {
    console.log("working data");
    // history.push('/login');
  };
  // getFilterOpportunities
  const getfilterData = (data) => {
    console.log({ data });
    getFilterOpportunities(data)
      .then((res) => {
        console.log({ res })
        if (res.data.length > 0) {
          let arr = res?.school_geo_points?.map((ele) => ({
            coordinates: {
              lat: parseFloat(ele.latitude),
              lng: parseFloat(ele.longitude),
            },
          }));

          setCoordinates((prevCoordinates) => [...prevCoordinates, ...arr]);
          setOpportunities(res.data);
          setOpportunitiesCount(res.record_count);

          // setTimeout(() => {
          //   redirectToHomePage();
          // }, 10000);
        }
        else {
          setCoordinates([]);
          setOpportunities([]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //pending data
  const getFilterFields = () => {
    getOpportunitiesFilterFields()
      .then((res) => {
        let { categories, countries, section, formationLevels } = res;
        if (categories || countries || section || formationLevels) {
          let categoriesData = categories?.map((ele) => {
            ele.label = ele.name;
            ele.value = ele.id;
            return ele;
          });
          let countriesData = countries?.map((ele) => {
            ele.label = ele.name;
            ele.value = ele.id;
            return ele
          })
          let formationlevelData = formationLevels?.map((ele) => {
            ele.label = ele.name;
            ele.value = ele.id;
            return ele
          })
          let sectionData = section?.map((ele) => {
            ele.label = ele.id;
            ele.value = ele.key;
            return ele
          })
          console.log({ categoriesData, countriesData });
          setFilterFileds({
            categories: categoriesData,
            countries: countriesData,
            formationlevel: formationlevelData,
            nationality: countriesData
            // section: [],
          });
        }
        // setFilterFileds();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getFilterFields();
  }, []);

  // useEffect(() => {
  //   let newData = {
  //     categories: "",
  //     locations: "",
  //     nationalities: "",
  //     levels: "",
  //   };
  //   getfilterData(newData);
  // }, []);

  useEffect(() => {
    getOpportunities(pagination.page, pagination.limit)
      .then((res) => {
        if (res) {
          let arr = res?.school_geo_points?.map((ele) => ({
            coordinates: {
              lat: parseFloat(ele.latitude),
              lng: parseFloat(ele.longitude),
            },
          }));

          setCoordinates((prevCoordinates) => [...prevCoordinates, ...arr]);
          setOpportunities(res?.data);
          setOpportunitiesCount(res?.record_count)

          // setPagination({
          //   page:1+pagination.page
          // })
          // setTimeout(() => {
          //   redirectToHomePage();
          // }, 10000);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  //*** handle scroll */

  const handleScroll = async () => {
    try {
      // if (
      //   window.innerHeight + document.documentElement.scrollTop ===
      //   document.documentElement.offsetHeight
      // ) {

      if (totalPage > pagination?.page + 1) {
        setLoading(true);
        await getOpportunities(pagination?.page + 1, pagination?.limit)
          .then((res) => {
            if (res.data.length > 0) {

              setOpportunities((prev) => [...prev, ...res.data]);
              setPagination({
                page: pagination.page + 1,
                limit: 11,
              });
              setTimeout(() => {
                setLoading(false);
              }, 1000);
            }
            else {
              setLoading(false)
            }

          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
          });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [pagination]);

  const onReseted = () => {
    console.log("reset in opptortunity")
    getOpportunities(0, 10)
      .then((res) => {
        if (res) {
          let arr = res?.school_geo_points?.map((ele) => ({
            coordinates: {
              lat: parseFloat(ele.latitude),
              lng: parseFloat(ele.longitude),
            },
          }));

          setCoordinates((prevCoordinates) => [...prevCoordinates, ...arr]);
          setOpportunities(res.data);
          // setOpportunities((prev)=>({
          //   page:0,
          //   limit:10
          // }));
          // setPagination({
          //   page:1+pagination.page
          // })
          // setTimeout(() => {
          //   redirectToHomePage();
          // }, 10000);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <div
        id="opportunity-page"
        className={`${isPreloader ? "d-none" : "d-block"}`}
      >
        <div className="container pt-16">
          {/* <div className="flex justify-between items-center text-ace-ace_title mt-23">
          <p className="lg:text-lg font-normal">Filtrez vos résultats</p>
        </div> */}
          {/* <div className="flex justify-between mb-3 mt-2">
            <Breadcrumbs
              subtitle="opportunites"
              subtitleLink="/opportunites"
              // extratitle="opportunites"
              // extratitleLink="/"
              currentTile="student opportunites"
            />
            <CommonIcon />
          </div> */}
          <Section
            title="Opportunités"
            sectionId="opportunities-last"
            sectionClasses="opportunities-last text-left text-azul-escuro font-montserrat text-2xl font-semibold "
            sectionInnerClasses="text-left"
          />
          <Maper
            withPopup
            icon={mkOpportunity}
            items={coordinates}
            // items={opportunities}
            redirectLink="/opportunites"
            className="opportunity-mapper"
          />

          <div className="mt-3">
            <div className="row">
              <div className="flex justify-between items-center text-ace-ace_title mt-23 px-0">
                <p className="lg:text-lg font-normal pl-2.5 ">
                  Filtrez vos résultats
                </p>
              </div>
              <div className="col-lg-12 mt-6  opportunities-filters">
                <FilterOpportunity
                  filterData={getfilterData}
                  filter={filterfileds ? filterfileds : filterfileds}
                  reset={onReseted}
                />
              </div>

              <div className="flex justify-between items-center opportunites-div my-4">
                <p className="text-sm  opportunites-par">
                  0 Koubagla, nous avons trouvé 10 opportunites pour vous
                </p>
                {/* <Col lg={2} sm={12}>
                  <Form.Group className="mb-0 py-4">
                    <Selecter
                      id="levels"
                      name="levels"
                      placeholder="Éducation min."
                      selecterClasses="filters-selects"
                      selecterClassesPrefix="filters-selects-prefix"
                      selected={data.levels || []}
                      options={LEVELS}
                      onSelected={onSelected}
                    />
                  </Form.Group>
                </Col> */}
              </div>
              <div className="col-lg-12">
                {/* {loading ? (
                  <h1>loading...</h1>
                ) : (
                <ListOpportunity items={opportunities} listerClasses="g-3" loading={loading}/>
                )} */}
                <ListOpportunity items={opportunities} listerClasses="g-3" loading={loading} />
                {totalPage > pagination?.page + 1 && (
                  <div className="load-more-btn-box text-center mt-5">
                    <button type="button" className="btn" onClick={handleScroll}>Load More</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
